module.exports = "/_next/static/images/CardProfile@2x-6a06cb08edc68f5ad4cd46a6a2d5b50b.webp";